'use client';

import React from 'react';
import { usePathname } from 'next/navigation';

import { Map } from '@/components/Map';
import { Media } from '@/components/Media';
import { NAV } from '@/constants';
import type { Misc } from '@/payload-types';

export const Component: React.FC<{
  title: string;
  misc: Misc;
}> = ({ title, misc }) => {
  const pathname = usePathname();
  const isContactsPage = pathname === NAV.contacts;

  const { phones, emails, address, workTime } = misc.refs;
  const { city, street, coords } = address || {};

  return (
    <section className="v-margin !mt-0" data-name="MapAndContacts">
      <div className="container">
        {!isContactsPage && <h2 className="h2 mb-10 md:mb-[30px]">{title}</h2>}

        <div className="mb-10 flex justify-between gap-5 md:mb-[30px] lg:flex-col">
          {phones?.[0] && (
            <div className="flex w-full max-w-[277px] flex-col gap-2">
              <p>Телефон</p>
              <a className="h6 link" href={`tel:${phones[0].phone}`}>
                {phones[0].phone}
              </a>

              {misc.socials && (
                <div className="flex gap-3">
                  {misc.socials.map((i) => (
                    <a href={i.link} target="_blank" key={i.id}>
                      <Media resource={i.image} />
                    </a>
                  ))}
                </div>
              )}
            </div>
          )}

          {emails?.[0] && (
            <div className="flex w-full max-w-[277px] flex-col gap-2">
              <p>Почта</p>
              <a className="h6 link" href={`mailto:${emails[0].email}`}>
                {emails[0].email}
              </a>
            </div>
          )}

          <div className="flex w-full max-w-[401px] flex-col gap-2">
            <p>Адрес</p>
            <p className="h6">
              {city}, {street}
            </p>
          </div>

          <div className="flex w-full max-w-[303px] flex-col gap-2">
            <p>Режим работы</p>
            <p className="h6">{workTime}</p>
          </div>
        </div>

        {coords && <Map coords={coords} />}
      </div>
    </section>
  );
};
